import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@/design-system/global.css';
import { App } from '@/app/App';
import { applyDocumentLang, getLocale } from '@/i18n';
import { bootStorage } from '@/services';

// The old site's storage keys and an already-expired session, before any request or stored preference is read.
bootStorage();
// The stored language (P12) before the first paint: `<html lang>` is right from the start.
applyDocumentLang(getLocale());

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing from index.html');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
